import SelectTableFilter from 'components/atoms/select-table-filter'
import InputSelectOptions from 'components/molecules/input-select-options'
import PhotoCurationStatusBadge from 'domains/merchant-product/atoms/photo-curation-status-badge'
import { PHOTO_CURATION_STATUS } from 'domains/merchant-product/constants'
import MerchantBadge from 'domains/merchant/atoms/merchant-badge'
import { MERCHANT_TYPE } from 'domains/merchant/constants'
import PropTypes from 'prop-types'
import React from 'react'
import { Input } from 'reactstrap'
import TimeUtil from 'utils/time-util'


const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const filterPropTypes = {
  column: PropTypes.object
}
/**
 * Merchant Product Table Columns
 */
const merchantProductPhotoCurationTableColumns = ({ onChangePhotoCurationStatus }) => {
  delete PHOTO_CURATION_STATUS.PENDING

  const MerchantTypeFilter = ({ column }) => {
    const options = Object.keys(MERCHANT_TYPE).map((key) => (
      {
        label : MERCHANT_TYPE[key],
        value : MERCHANT_TYPE[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const MerchantTypeCell = (row) => <MerchantBadge merchant_type={ row.cell.value } />

  const PhotoCurationStatusCell = (row) => <PhotoCurationStatusBadge photoCurationStatus={ row.cell.value } />

  const PhotoCurateCell = ({ cell: { row } }) => (
    <Input
      type='select'
      name='photo_curation_status'
      onChange={ (event) => onChangePhotoCurationStatus(event,row) }
    >
      <InputSelectOptions options={ PHOTO_CURATION_STATUS } keyPrefix={ 'photo-curation-status' } />
    </Input>
  )

  const DateCell = (row) => TimeUtil.format(row.cell.value)

  MerchantTypeFilter.propTypes = filterPropTypes
  PhotoCurateCell.propTypes    = actionCellPropTypes

  return (
    [
      {
        Header  : 'Merchant',
        columns : [
          {
            Header   : 'Name',
            id       : 'merchant_name',
            accessor : 'merchant.name'
          },
          {
            Header   : 'Code',
            id       : 'merchant_code',
            accessor : 'merchant.code'
          },
          {
            Header   : 'Type',
            accessor : 'merchant.merchant_type',
            id       : 'merchant_type',
            Filter   : MerchantTypeFilter,
            Cell     : MerchantTypeCell
          }
        ]
      },
      {
        Header  : 'Merchant Product',
        columns : [
          {
            Header   : 'SKU',
            accessor : 'sku'
          },
          {
            Header   : <>Merchant<br/>SKU</>,
            accessor : 'merchant_sku'
          },
          {
            Header         : 'Name',
            accessor       : 'name',
            disableFilters : true
          },
          {
            Header         : 'Category',
            accessor       : 'category',
            disableFilters : true
          },
          {
            Header         : <>Photo Curation<br/> Status</>,
            accessor       : 'photo_curation_status',
            disableFilters : true,
            Cell           : PhotoCurationStatusCell
          },
          {
            Header         : <>Photo Curation<br/> Date</>,
            accessor       : 'photo_curation_date',
            disableFilters : true,
            Cell           : DateCell
          }
        ]
      },
      {
        Header : 'Curation Action',
        id     : 'curate_action',
        Cell   : PhotoCurateCell
      }
    ]
  )
}

export default merchantProductPhotoCurationTableColumns
